import { graphql } from "@/gql";

export const createOffSessionSetupIntentMutation = graphql(`
  mutation CreateOffSessionSetupIntent($input: CreateSetupIntentInput!) {
    createSetupIntent(input: $input)
  }
`);
